import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreLabel?: string;
  moreTo?: string;
  icon?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreLabel,
  moreTo,
  icon,
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div>
        <h2 className="flex items-center gap-2 text-lg font-semibold text-foreground-950 md:text-2xl">
          {icon && (
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-100 text-primary-600">
              <i className={`${icon} text-lg`} />
            </span>
          )}
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {moreLabel && moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}